import { createStore } from "vuex";
import { auth } from "./auth.module";
import router from "@/router";

export default createStore({
  state: {
    hideConfigButton: false,
    isPinned: true,
    showConfig: false,
    sidebarType: "bg-gradient-dark",
    isRTL: false,
    color: "#f9dd4b",
    logoTheme2: "",
    mainThemeColorTheme2: "",
    primaryButtonColorTheme2: "",
    // KSK063: per-element kiosk colours (branch_info.kiosk_custom_colors).
    kioskColors: null,
    // KSK105: kiosk background colour (branch_info.kiosk_card_color).
    kioskCardColor: null,
    isNavFixed: false,
    isAbsolute: false,
    showNavs: true,
    showSidenav: true,
    showNavbar: true,
    showFooter: true,
    showMain: true,
    isDarkMode: false,
    navbarFixed:
      "position-sticky blur shadow-blur left-auto top-1 z-index-sticky px-0 mx-4",
    absolute: "position-absolute px-4 mx-0 w-100 z-index-2",
    cartName: "",
    prefixUrl: "",
    merchantCode: "",
    branchCode: "",
    error: {}
  },
  modules: {
    auth,
  },
  mutations: {
    toggleConfigurator(state) {
      state.showConfig = !state.showConfig;
    },
    navbarMinimize(state) {
      const sidenav_show = document.querySelector(".g-sidenav-show");

      if (sidenav_show.classList.contains("g-sidenav-pinned")) {
        sidenav_show.classList.remove("g-sidenav-pinned");
        state.isPinned = true;
      } else {
        sidenav_show.classList.add("g-sidenav-pinned");
        state.isPinned = false;
      }
    },
    navbarFixed(state) {
      if (state.isNavFixed === false) {
        state.isNavFixed = true;
      } else {
        state.isNavFixed = false;
      }
    },
    toggleEveryDisplay(state) {
      state.showNavbar = !state.showNavbar;
      state.showSidenav = !state.showSidenav;
      state.showFooter = !state.showFooter;
    },
    toggleHideConfig(state) {
      state.hideConfigButton = !state.hideConfigButton;
    },
    color(state, payload) {
      state.color = payload;
    },
    theme2(state, payload) {
      state.logoTheme2 = payload.logo ?? "";
      state.mainThemeColorTheme2 = payload.mainColor ?? "";
      state.primaryButtonColorTheme2 = payload.buttonColor ?? "";
    },
    kioskColors(state, payload) {
      state.kioskColors = payload || null;
    },
    kioskCardColor(state, payload) {
      state.kioskCardColor = payload || null;
    },
    prefixUrl(state, payload) {
      state.prefixUrl = payload;
    },
    merchantCode(state, payload) {
      state.merchantCode = payload;
    },
    branchCode(state, payload) {
      state.branchCode = payload;
    },
    error(state, payload) {
      state.error = payload;
    }
  },
  actions: {
    setColor({ commit }, payload) {
      commit("color", payload);
    },
    setTheme2({ commit }, payload) {
      commit("theme2", payload);
    },
    setKioskColors({ commit }, payload) {
      commit("kioskColors", payload);
    },
    setKioskCardColor({ commit }, payload) {
      commit("kioskCardColor", payload);
    },
    cartName({ state }, payload = 'ORDER_INFO_') {
      const route = router.currentRoute.value;
      const merchantCode = route.params.merchant_code || state.merchantCode || '';
      const branchCode = route.params.branch_code || state.branchCode || '';
      return payload + merchantCode + '_' + branchCode;
    },
    prefixUrl({ commit, state }, payload) {
      // Prefer route-param values from payload so the URL is correct even before
      // checkMerchantAndBranch sets Vuex state (Cover.vue created() runs first).
      let merchantCode = payload.merchant_code || state.merchantCode;
      merchantCode = merchantCode ? `/${merchantCode}` : "";
      let branchCode = payload.branch_code || state.branchCode;
      branchCode = branchCode ? `/${branchCode}` : "";
      let type = payload.type ?? '';
      type = type ? `/${type}` : "";
      let tableCode = payload.table_code ?? '';
      tableCode = tableCode ? `/${tableCode}` : "";
      let prefixUrl = merchantCode + type + branchCode + tableCode;

      commit("prefixUrl", prefixUrl);

      return prefixUrl;
    },
    setMerchantCode({ commit }, payload) {
      commit("merchantCode", payload);
    },
    setBranchCode({ commit }, payload) {
      commit("branchCode", payload);
    },
    setError({ commit }, payload) {
      commit("error", payload)
    }
  },
  getters: {},
});
